(function() {
  'use strict';

  window.csBundleBuilder = {
    STOREFRONT_ACCESS_TOKEN: 'b87a263345b20472ba924435a8815712',

    state: {
      currentStep: 1,
      selectedCategoryButton: null,
      selectedBundleCategoryValue: null,
      packSize: null,
      packVariantTitle: null,
      selectedStyle: null,
      selectedPattern: null,
      selectedProducts: [],
      availableStyles: [],
      availablePatterns: [],
      availableProducts: [],
      patternImages: {}
    },

    // --------- UTILITY ----------
    clearStepTitles: function() {
      var packTitle = document.querySelector('#cs-step-2 .cs-selected-text');
      if (packTitle) packTitle.textContent = '';
      var styleTitle = document.querySelector('#cs-step-3 .cs-selected-text');
      if (styleTitle) styleTitle.textContent = '';
      var patternTitle = document.querySelector('#cs-step-4 .cs-selected-text');
      if (patternTitle) patternTitle.textContent = '';
    },

    showBundleError: function(message) {
      var errorBox = document.getElementById('cs-bundle-error');
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.style.display = 'block';
    },

    clearBundleError: function() {
      var errorBox = document.getElementById('cs-bundle-error');
      if (!errorBox) return;
      errorBox.textContent = '';
      errorBox.style.display = 'none';
    },

    // --------- INIT & STATE RESTORE ----------
    init: function() {
      this.clearStepTitles();
      this.bindEvents();
      this.showStepsUpTo(1);

      var hasURLParams = window.location.search.includes('category');
      this.restoreStateFromURL();

      if (!hasURLParams) {
        this.renderPackButtons();
        setTimeout(() => {
          this.showStepsUpTo(2);
        }, 500);
      }

      console.log('Bundle builder initialized');
    },

    restoreStateFromURL: function() {
      var params = new URLSearchParams(window.location.search);
      var categoryParam = params.get('category');
      var packParam = params.get('pack');
      var self = this;

      if (!categoryParam) return;

      document.querySelectorAll('.cs-category-card').forEach(function(button) {
        var btnTxt = button.textContent.trim();
        var mapped = (
          btnTxt === "Men's Socks" ? "Men" :
          btnTxt === "Women's Socks" ? "Women" :
          btnTxt === "Yoga & Pilates" ? "Yoga and Pilates" : null
        );

        if (mapped === categoryParam) {
          button.classList.add('active');
          self.state.selectedCategoryButton = btnTxt;
          self.state.selectedBundleCategoryValue = categoryParam;
        } else {
          button.classList.remove('active');
        }
      });

      this.renderPackButtons();

      if (packParam) {
        this.state.packSize = parseInt(packParam);
        this.state.packVariantTitle = packParam + ' Pack';

        setTimeout(function() {
          var packButton = document.querySelector('.cs-pack-card[data-pack="' + packParam + '"]');
          if (packButton) {
            packButton.classList.add('active');
          }
          self.updatePackDisplayElements(false);
        }, 200);
      }

      this.loadStyles();
      setTimeout(function() {
        self.showStepsUpTo(3);
      }, 300);
    },

    bindEvents: function() {
      var self = this;
      document.querySelectorAll('.cs-category-card').forEach(function(card) {
        card.addEventListener('click', function(e) {
          self.selectCategory(e.currentTarget);
        });
      });

      var checkoutBtn = document.getElementById('cs-checkout-btn');
      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', function() {
          self.addBundleToCart();
        });
      }
    },

    // --------- CATEGORY ---------
    selectCategory: function(cardElement) {
      var buttonText = cardElement.textContent.trim();
      var bundleCategoryMetafieldValue = (
        buttonText === "Men's Socks" ? "Men" :
        buttonText === "Women's Socks" ? "Women" :
        buttonText === "Yoga & Pilates" ? "Yoga and Pilates" : null
      );

      document.querySelectorAll('.cs-category-card').forEach(function(card) {
        card.classList.remove('active');
      });
      cardElement.classList.add('active');

      this.state.selectedCategoryButton = buttonText;
      this.state.selectedBundleCategoryValue = bundleCategoryMetafieldValue;

      this.updateURL();
      this.clearSubsequentSelections(1);
      this.renderPackButtons();
      this.clearStepTitles();
      this.clearBundleError();

      if (this.state.packSize) {
        var self = this;
        setTimeout(function() {
          var currentPackBtn = document.querySelector('.cs-pack-card[data-pack="' + self.state.packSize + '"]');
          if (currentPackBtn) {
            currentPackBtn.classList.add('active');
          }
        }, 100);
      }

      if (this.state.selectedBundleCategoryValue) {
        this.loadStyles();
        var self = this;
        setTimeout(function() {
          self.showStepsUpTo(3);
        }, 300);
      }
    },

    showStepsUpTo: function(stepNumber) {
      for (var i = 1; i <= stepNumber; i++) {
        var stepSection = document.getElementById('cs-step-' + i);
        if (stepSection) {
          stepSection.classList.add('active');
          stepSection.style.display = 'block';
        }
      }
      for (var j = stepNumber + 1; j <= 5; j++) {
        var futureSection = document.getElementById('cs-step-' + j);
        if (futureSection) {
          futureSection.classList.remove('active');
          futureSection.style.display = 'none';
        }
      }
      this.state.currentStep = stepNumber;
    },

    // --------- PACK SIZE ---------
    renderPackButtons: function() {
      var container = document.querySelector("#cs-step-2 .cs-pack-buttons");
      if (!container) return;

      var pricesArr = this.getPackPricesForCategory(this.state.selectedBundleCategoryValue);
      container.innerHTML = "";
      var self = this;

      pricesArr.forEach(function(packObj) {
        var btn = document.createElement("button");
        btn.className = "cs-pack-card";
        btn.setAttribute("data-pack", packObj.pack);
        btn.setAttribute("data-price", packObj.price);
        btn.textContent = packObj.text;
        btn.addEventListener("click", function() {
          var titleElem = document.querySelector('#cs-step-2 .cs-selected-text');
          if (titleElem) titleElem.textContent = packObj.pack + ' pack';
          self.selectPack(btn, true);
        });
        container.appendChild(btn);
      });
    },

    selectPack: function(cardElement, userAction) {
      var pack = cardElement.dataset.pack;
      var newPackSize = parseInt(pack, 10);
      var params = new URLSearchParams();

      if (this.state.selectedBundleCategoryValue) {
        params.set('category', this.state.selectedBundleCategoryValue);
      }
      params.set('pack', pack);

      if (!userAction) {
        this.state.packSize = newPackSize;
        this.state.packVariantTitle = pack + ' Pack';
        document.querySelectorAll('.cs-pack-card').forEach(function(card) {
          card.classList.remove('active');
        });
        cardElement.classList.add('active');
        this.updatePackDisplayElements(false);
        return;
      }

      window.location.href = window.location.pathname + '?' + params.toString();
    },

    updatePackDisplayElements: function(showTitle) {
      var packBadge = document.querySelector('.cs-pack-label-badge');
      var pricesArr = this.getPackPricesForCategory(this.state.selectedBundleCategoryValue || "");
      if (packBadge && this.state.packSize) {
        var found = pricesArr.find(function(p) { return p.pack === window.csBundleBuilder.state.packSize; });
        packBadge.textContent = found ? found.text : "Buy " + this.state.packSize + " Pack";
      }

      var stepTitle = document.querySelector('#cs-step-2 .cs-selected-text');
      if (stepTitle && showTitle && this.state.packSize) {
        stepTitle.textContent = this.state.packSize + ' pack';
      }

      this.updateEmptySlots();
      this.updateBundleDisplay();
    },

    // --------- STYLE ---------
    loadStyles: function() {
      console.log('Loading styles for category:', this.state.selectedBundleCategoryValue);

      var self = this;
      var query = `query getProductsWithStyles($handle: String!) {
        collection(handle: $handle) {
          products(first: 250) {
            edges {
              node {
                id
                handle
                title
                availableForSale
                bundleCategoryMetafield: metafield(namespace: "custom", key: "bundle_category") { value }
                styleMetafield: metafield(namespace: "custom", key: "style") { value }
              }
            }
          }
        }
      }`;

      this.queryStorefront(query, { handle: 'bundle-collection' })
        .then(function(data) {
          console.log('Styles API response:', data);

          var styles = new Set();
          if (data.data && data.data.collection && data.data.collection.products) {
            data.data.collection.products.edges.forEach(function(edge) {
              var product = edge.node;
              if (
                product.availableForSale &&
                product.bundleCategoryMetafield &&
                product.bundleCategoryMetafield.value === self.state.selectedBundleCategoryValue &&
                product.styleMetafield &&
                product.styleMetafield.value
              ) {
                styles.add(product.styleMetafield.value);
              }
            });
          }
          self.state.availableStyles = Array.from(styles);
          self.renderStyles();
        })
        .catch(function(error) {
          console.error('Error loading styles:', error);
          self.state.availableStyles = [];
          self.renderStyles();
        });
    },

    renderStyles: function() {
      var container = document.getElementById('cs-style-container');
      if (!container) {
        console.error('Style container not found!');
        return;
      }

      container.innerHTML = '';

      if (this.state.availableStyles.length === 0) {
        container.innerHTML = '<div class="no-styles-message"><h3>Select Category First</h3><p>Choose a category to see available styles</p></div>';
        return;
      }

      var self = this;
      this.state.availableStyles.forEach(function(style) {
        var styleCard = document.createElement('div');
        styleCard.className = 'cs-option-card';
        styleCard.dataset.style = style;
        var imgSrc = (window.bundleImagesConfig && window.bundleImagesConfig.styles && window.bundleImagesConfig.styles[style])
          ? window.bundleImagesConfig.styles[style]
          : 'https://via.placeholder.com/150x150?text=' + encodeURIComponent(style);

        styleCard.innerHTML = '<img src="' + imgSrc + '" alt="' + self.escapeHtml(style) + '" loading="lazy"><h3>' + self.escapeHtml(style) + '</h3>';
        styleCard.addEventListener('click', function() {
          var titleElem = document.querySelector('#cs-step-3 .cs-selected-text');
          if (titleElem) titleElem.textContent = style;
          self.selectStyle(styleCard, true);
        });
        container.appendChild(styleCard);
      });
    },

    selectStyle: function(cardElement, userAction) {
      var selectedStyle = cardElement.dataset.style;

      document.querySelectorAll('#cs-style-container .cs-option-card').forEach(function(card) {
        card.classList.remove('selected');
      });
      cardElement.classList.add('selected');
      this.state.selectedStyle = selectedStyle;

      if (!userAction) return;

      this.clearSubsequentSelections(3);
      this.loadPatterns();
      var self = this;
      setTimeout(function() {
        self.showStepsUpTo(4);
      }, 300);
    },

    // --------- PATTERNS ---------
    loadPatterns: function() {
      console.log('Loading patterns for category:', this.state.selectedBundleCategoryValue, 'style:', this.state.selectedStyle);

      var self = this;
      var query = `query getProductsWithPatterns($handle: String!) {
        collection(handle: $handle) {
          products(first: 250) {
            edges {
              node {
                id
                title
                availableForSale
                images(first: 1) { edges { node { originalSrc } } }
                bundleCategoryMetafield: metafield(namespace: "custom", key: "bundle_category") { value }
                styleMetafield: metafield(namespace: "custom", key: "style") { value }
                patternMetafield: metafield(namespace: "custom", key: "pattern_name") { value }
              }
            }
          }
        }
      }`;

      this.queryStorefront(query, { handle: 'bundle-collection' })
        .then(function(data) {
          var patterns = new Set();
          var patternImages = {};

          if (data.data && data.data.collection && data.data.collection.products) {
            data.data.collection.products.edges.forEach(function(edge) {
              var product = edge.node;
              if (
                product.availableForSale &&
                product.bundleCategoryMetafield &&
                product.bundleCategoryMetafield.value === self.state.selectedBundleCategoryValue &&
                product.styleMetafield &&
                product.styleMetafield.value === self.state.selectedStyle &&
                product.patternMetafield &&
                product.patternMetafield.value
              ) {
                patterns.add(product.patternMetafield.value);

                if (!patternImages[product.patternMetafield.value] && product.images.edges.length > 0) {
                  patternImages[product.patternMetafield.value] = product.images.edges[0].node.originalSrc;
                }
              }
            });
          }

          self.state.availablePatterns = Array.from(patterns);
          self.state.patternImages = patternImages;
          self.renderPatterns();
        })
        .catch(function(error) {
          console.error('Error loading patterns:', error);
          self.state.availablePatterns = [];
          self.renderPatterns();
        });
    },

    renderPatterns: function() {
      var container = document.getElementById('cs-pattern-container');
      if (!container) {
        console.error('Pattern container not found!');
        return;
      }

      container.innerHTML = '';

      if (this.state.availablePatterns.length === 0) {
        container.innerHTML = '<div class="no-patterns-message"><h3>No patterns found</h3><p>No patterns available for selected style</p></div>';
        return;
      }

      var self = this;
      this.state.availablePatterns.forEach(function(pattern) {
        var patternImg = document.createElement('img');
        patternImg.dataset.pattern = pattern;
        patternImg.alt = pattern;
        patternImg.title = pattern;
        patternImg.loading = 'lazy';

        var imageSrc = self.state.patternImages && self.state.patternImages[pattern]
          ? self.state.patternImages[pattern]
          : 'https://via.placeholder.com/60x60?text=' + encodeURIComponent(pattern.substring(0, 2));

        patternImg.src = imageSrc;

        patternImg.addEventListener('click', function(e) {
          e.preventDefault();
          var titleElem = document.querySelector('#cs-step-4 .cs-selected-text');
          if (titleElem) titleElem.textContent = pattern;
          self.selectPattern(patternImg, true);
        });

        container.appendChild(patternImg);
      });
    },

    selectPattern: function(imgElement, userAction) {
      var selectedPattern = imgElement.dataset.pattern;

      document.querySelectorAll('#cs-pattern-container img').forEach(function(img) {
        img.classList.remove('selected');
      });
      imgElement.classList.add('selected');
      this.state.selectedPattern = selectedPattern;

      if (!userAction) return;

      this.loadProducts();
      var self = this;
      setTimeout(function() {
        self.showStepsUpTo(5);
      }, 300);
    },

    // --------- PRODUCTS ---------
    loadProducts: function() {
      console.log('Loading products for:', this.state.selectedBundleCategoryValue, this.state.selectedStyle, this.state.selectedPattern, this.state.packVariantTitle);

      var self = this;
      var query = `query getFilteredProducts($handle: String!) {
        collection(handle: $handle) {
          products(first: 250) {
            edges {
              node {
                id
                handle
                title
                availableForSale
                images(first: 2) { edges { node { originalSrc altText } } }
                bundleCategoryMetafield: metafield(namespace: "custom", key: "bundle_category") { value }
                styleMetafield: metafield(namespace: "custom", key: "style") { value }
                patternMetafield: metafield(namespace: "custom", key: "pattern_name") { value }
                variants(first: 10) {
                  edges {
                    node {
                      id
                      title
                      availableForSale
                      price { amount }
                    }
                  }
                }
              }
            }
          }
        }
      }`;

      this.queryStorefront(query, { handle: 'bundle-collection' })
        .then(function(data) {
          var filteredProducts = [];

          if (data.data && data.data.collection && data.data.collection.products) {
            data.data.collection.products.edges.forEach(function(edge) {
              var product = edge.node;

              if (
                product.availableForSale &&
                product.bundleCategoryMetafield &&
                product.bundleCategoryMetafield.value === self.state.selectedBundleCategoryValue &&
                product.styleMetafield &&
                product.styleMetafield.value === self.state.selectedStyle &&
                product.patternMetafield &&
                product.patternMetafield.value === self.state.selectedPattern
              ) {
                var matchingVariant = null;
                product.variants.edges.forEach(function(variantEdge) {
                  var variant = variantEdge.node;
                  if (variant.availableForSale && variant.title === self.state.packVariantTitle) {
                    matchingVariant = variant;
                  }
                });

                if (matchingVariant) {
                  filteredProducts.push({
                    id: product.id,
                    handle: product.handle,
                    title: product.title,
                    images: product.images.edges.map(function(edge) {
                      return { src: edge.node.originalSrc };
                    }),
                    selectedVariant: {
                      id: matchingVariant.id,
                      title: matchingVariant.title,
                      price: parseFloat(matchingVariant.price.amount)
                    },
                    pattern: product.patternMetafield.value,
                    style: product.styleMetafield.value,
                    bundleCategory: product.bundleCategoryMetafield.value
                  });
                }
              }
            });
          }

          self.state.availableProducts = filteredProducts;
          self.renderProductsLarge();
        })
        .catch(function(error) {
          console.error('Error loading products:', error);
          self.state.availableProducts = [];
          self.renderProductsLarge();
        });
    },

    renderProductsLarge: function() {
      var container = document.getElementById('cs-products-container');
      if (!container) return;
      container.innerHTML = '';

      if (this.state.availableProducts.length === 0) {
        container.innerHTML = '<div class="no-products-message"><h3>No products found</h3><p>No products match all criteria with the selected pack variant</p></div>';
        return;
      }

      var self = this;
      this.state.availableProducts.forEach(function(product) {
        var productCard = document.createElement('div');
        productCard.className = 'cs-product-card-large';
        var price = product.selectedVariant.price;
        var imageSrc = product.images && product.images[0] ? product.images[0].src : 'https://via.placeholder.com/250x250?text=Product';
        var variantId = product.selectedVariant.id;
        var variantTitle = product.selectedVariant.title;

        var cardHtml = '<div class="cs-product-images-row">';
        cardHtml += '<img src="' + imageSrc + '" alt="' + self.escapeHtml(product.title) + '" loading="lazy">';
        if (product.images && product.images[1]) {
          cardHtml += '<img src="' + product.images[1].src + '" alt="' + self.escapeHtml(product.title) + '" loading="lazy">';
        } else {
          cardHtml += '<img src="https://via.placeholder.com/250x250?text=Product" alt="' + self.escapeHtml(product.title) + '" loading="lazy">';
        }
        cardHtml += '</div>';
        cardHtml += '<h4>' + self.escapeHtml(product.title) + '</h4>';
        cardHtml += '<button class="cs-add-btn-large">Add to Bundle</button>';

        productCard.innerHTML = cardHtml;
        var addBtn = productCard.querySelector('.cs-add-btn-large');
        addBtn.addEventListener('click', function() {
          self.addToBundle(product.id, product.title, imageSrc, price, variantId, variantTitle);
        });
        container.appendChild(productCard);
      });
    },

    // --------- BUNDLE MANAGEMENT ---------
    addToBundle: function(productId, title, image, price, variantId, variantTitle) {
      console.log('Adding to bundle:', title, '- Variant:', variantTitle, '- Price:', price);

      if (!this.state.packSize) {
        this.showBundleError('Please select pack size first.');
        return;
      }

      if (this.state.selectedProducts.length >= this.state.packSize) {
        this.showBundleError('Your bundle is already full. Please remove a product first.');
        return;
      }

      this.clearBundleError();

      this.state.selectedProducts.push({
        id: productId,
        title: title,
        image: image,
        price: parseFloat(price),
        variantId: variantId,
        variantTitle: variantTitle,
        pattern: this.state.selectedPattern,
        style: this.state.selectedStyle,
        bundleCategory: this.state.selectedBundleCategoryValue
      });

      console.log('Product added. Bundle now has:', this.state.selectedProducts.length, 'of', this.state.packSize, 'products');

      this.updateBundleDisplay();

      if (this.state.selectedProducts.length === this.state.packSize) {
        this.completeBundleSelection();
      }
    },

    updateBundleDisplay: function() {
      var container = document.getElementById('cs-selected-items');
      if (!container || !this.state.packSize) return;

      console.log('Updating bundle display - Pack size:', this.state.packSize, 'Selected products:', this.state.selectedProducts.length);

      container.innerHTML = '';
      var self = this;

      this.state.selectedProducts.forEach(function(product, index) {
        var bundleItem = document.createElement('div');
        bundleItem.className = 'cs-item-slot filled';
        bundleItem.innerHTML =
          '<div class="cs-slot-column cs-image-column">' +
            '<img src="' + product.image + '" alt="' + self.escapeHtml(product.title) + '" class="cs-product-image" loading="lazy">' +
          '</div>' +
          '<div class="cs-slot-column cs-text-column">' +
            '<div class="cs-product-title">' + self.escapeHtml(product.title) + '</div>' +
          '</div>' +
          '<div class="cs-slot-column cs-action-column">' +
            '<button class="cs-remove-btn" onclick="csBundleBuilder.removeFromBundle(' + index + ')">Remove</button>' +
          '</div>';
        container.appendChild(bundleItem);
      });

      for (var i = this.state.selectedProducts.length; i < this.state.packSize; i++) {
        var emptySlot = document.createElement('div');
        emptySlot.className = 'cs-item-slot empty';
        emptySlot.innerHTML =
          '<div class="cs-slot-column cs-image-column">' +
            '<div class="cs-slot-placeholder"></div>' +
          '</div>' +
          '<div class="cs-slot-column cs-text-column">' +
            '<span class="cs-add-text">Add Product</span>' +
          '</div>' +
          '<div class="cs-slot-column cs-action-column"></div>';

        emptySlot.addEventListener('click', function() {
          var productsSection = document.getElementById('cs-step-5');
          if (productsSection) {
            productsSection.scrollIntoView({ behavior: 'smooth' });
          }
        });

        container.appendChild(emptySlot);
      }

      this.updatePricing();

      var checkoutBtn = document.getElementById('cs-checkout-btn');
      if (checkoutBtn) {
        if (this.state.selectedProducts.length === this.state.packSize) {
          checkoutBtn.disabled = false;
          checkoutBtn.classList.add('enabled');
          checkoutBtn.textContent = 'Add Bundle to Cart - Rs. ' + this.calculateBundleTotal();
          this.clearBundleError();
        } else {
          var remaining = this.state.packSize - this.state.selectedProducts.length;
          checkoutBtn.disabled = true;
          checkoutBtn.classList.remove('enabled');
          checkoutBtn.textContent = 'Complete Bundle First';
          this.showBundleError('Please add ' + remaining + ' more product' + (remaining > 1 ? 's' : '') + ' to complete your ' + this.state.packSize + ' pack.');
        }
      }
    },

    removeFromBundle: function(index) {
      console.log('Removing product from bundle at index:', index);

      if (index >= 0 && index < this.state.selectedProducts.length) {
        this.state.selectedProducts.splice(index, 1);
        this.updateBundleDisplay();
      }
    },

    completeBundleSelection: function() {
      console.log('Bundle complete! Ready for checkout.');

      var checkoutBtn = document.getElementById('cs-checkout-btn');
      if (checkoutBtn) {
        checkoutBtn.disabled = false;
        checkoutBtn.classList.add('enabled');
        checkoutBtn.textContent = 'Add Bundle to Cart - Rs. ' + this.calculateBundleTotal();
      }

      this.clearBundleError();
    },

    calculateBundleTotal: function() {
      return this.state.selectedProducts.reduce(function(total, product) {
        return total + product.price;
      }, 0).toFixed(0);
    },

    updatePricing: function() {
      var subtotal = this.state.selectedProducts.reduce(function(sum, product) {
        return sum + product.price;
      }, 0);

      var savingsPercentage = 0;
      if (this.state.packSize === 3) {
        savingsPercentage = 17;
      } else if (this.state.packSize === 6) {
        savingsPercentage = 21;
      }

      var discount = Math.round(subtotal * (savingsPercentage / 100));
      var finalTotal = subtotal - discount;

      var subtotalElement = document.getElementById('cs-subtotal');
      var savingsElement = document.getElementById('cs-savings');
      var totalElement = document.getElementById('cs-total');

      if (subtotalElement) {
        subtotalElement.textContent = subtotal > 0 ? 'Rs. ' + subtotal.toFixed(0) : 'Rs. 0';
      }
      if (savingsElement) {
        if (this.state.selectedProducts.length === this.state.packSize && subtotal > 0) {
          savingsElement.textContent = savingsPercentage + '% off';
        } else {
          savingsElement.textContent = '0% off';
        }
      }
      if (totalElement) {
        totalElement.textContent = this.state.selectedProducts.length === this.state.packSize
          ? 'Rs. ' + finalTotal.toFixed(0)
          : 'Rs. ' + subtotal.toFixed(0);
      }
    },

    addBundleToCart: function() {
      if (!this.state.packSize) {
        this.showBundleError('Please select a pack size first.');
        return;
      }

      if (this.state.selectedProducts.length !== this.state.packSize) {
        var remaining = this.state.packSize - this.state.selectedProducts.length;
        this.showBundleError('Your bundle is incomplete. Please add ' + remaining + ' more product' + (remaining > 1 ? 's' : '') + ' before adding to cart.');
        return;
      }

      this.clearBundleError();
      console.log('Adding bundle to cart...');

      var checkoutBtn = document.getElementById('cs-checkout-btn');
      if (checkoutBtn) {
        checkoutBtn.textContent = 'Adding to Cart...';
        checkoutBtn.disabled = true;
      }

      var self = this;
      var bundleId = Date.now();

      var cartItems = this.state.selectedProducts.map(function(product, index) {
        var variantId = product.variantId;

        if (typeof variantId === 'string' && variantId.includes('gid://shopify/ProductVariant/')) {
          variantId = variantId.split('/').pop();
        }

        return {
          id: variantId,
          quantity: 1,
          properties: {
            '_bundle_id': bundleId,
            '_bundle_pack': self.state.packVariantTitle,
            '_bundle_position': index + 1,
            '_bundle_total_items': self.state.packSize,
            '_pattern': product.pattern,
            '_style': product.style,
            '_category': product.bundleCategory,
            '_is_bundle_item': 'true'
          }
        };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: cartItems
        })
      })
      .then(function(response) {
        if (!response.ok) {
          return response.text().then(function(text) {
            throw new Error('Failed to add to cart: ' + response.status + ' - ' + text);
          });
        }
        return response.json();
      })
      .then(function(data) {
        console.log('✅ Bundle added to cart successfully:', data);
        self.clearBundleError();
        window.location.href = '/cart';
      })
      .catch(function(error) {
        console.error('❌ Error adding bundle to cart:', error);

        if (checkoutBtn) {
          checkoutBtn.disabled = false;
          checkoutBtn.textContent = 'Add Bundle to Cart - Rs. ' + self.calculateBundleTotal();
        }

        self.showBundleError('Error adding bundle to cart. Please try again.');
      });
    },

    updateEmptySlots: function() {
      var emptySlots = document.querySelector('.cs-empty-slots');
      if (!emptySlots || !this.state.packSize) return;
      emptySlots.innerHTML = '';
      for (var i = 0; i < this.state.packSize; i++) {
        var slot = document.createElement('div');
        slot.className = 'cs-item-slot empty';
        slot.innerHTML =
          '<div class="cs-slot-column cs-image-column">' +
            '<div class="cs-slot-placeholder"></div>' +
          '</div>' +
          '<div class="cs-slot-column cs-text-column">' +
            '<span class="cs-add-text">Add Product</span>' +
          '</div>' +
          '<div class="cs-slot-column cs-action-column"></div>';
        emptySlots.appendChild(slot);
      }
    },

    // ----------- Required Functions -----------
    getPackPricesForCategory: function(categoryValue) {
      if (categoryValue === "Men") return [{pack: 3, text: "Buy 3 at Rs. 999", price: 999}, {pack: 6, text: "Buy 6 at Rs. 1998", price: 1998}];
      if (categoryValue === "Women") return [{pack: 3, text: "Buy 3 at Rs. 849", price: 849}, {pack: 6, text: "Buy 6 at Rs. 1650", price: 1650}];
      if (categoryValue === "Yoga and Pilates") return [{pack: 3, text: "Buy 3 at Rs. 999", price: 999}, {pack: 6, text: "Buy 6 at Rs. 1998", price: 1998}];
      return [{pack: 3, text: "Buy 3 Pack", price: 0}, {pack: 6, text: "Buy 6 Pack", price: 0}];
    },

    queryStorefront: function(query, variables) {
      var shopifyRoutes = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      return fetch(shopifyRoutes + 'api/2023-04/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this.STOREFRONT_ACCESS_TOKEN
        },
        body: JSON.stringify({ query: query, variables: variables || {} })
      })
      .then(function(response) {
        if (!response.ok) throw new Error('API request failed: ' + response.status);
        return response.json();
      })
      .then(function(data) {
        if (data.errors) throw new Error('GraphQL Error: ' + JSON.stringify(data.errors));
        return data;
      });
    },

    updateURL: function() {
      var params = new URLSearchParams(window.location.search);
      if (this.state.selectedBundleCategoryValue) params.set('category', this.state.selectedBundleCategoryValue);
      if (this.state.packSize) params.set('pack', this.state.packSize);
      var newURL = window.location.pathname + '?' + params.toString();
      history.pushState(this.state, '', newURL);
    },

    clearSubsequentSelections: function(fromStep) {
      if (fromStep <= 1) {
        this.state.selectedStyle = null;
        this.state.selectedPattern = null;
        this.state.availableStyles = [];
        this.state.availablePatterns = [];
        this.state.availableProducts = [];
        this.state.selectedProducts = [];
      }
      if (fromStep <= 2) {
        this.state.selectedStyle = null;
        this.state.selectedPattern = null;
        this.state.availablePatterns = [];
        this.state.availableProducts = [];
      }
      if (fromStep <= 3) {
        this.state.selectedPattern = null;
        this.state.availableProducts = [];
      }
    },

    escapeHtml: function(text) {
      if (!text) return '';
      var div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      window.csBundleBuilder.init();
    });
  } else {
    window.csBundleBuilder.init();
  }
})();